import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { AuthHttp } from 'app/infrastructure/common';
import { AppSettings } from 'app/infrastructure/settings';
import { UserProductConfigModel } from 'app/data/models/master/op';

@Injectable()
export class OnlineUserProductConfigService {
    constructor(private http: AuthHttp) { }

    getOnlineUserProductConfig(ownerCode: string) {
        let params: URLSearchParams = new URLSearchParams();        
        params.set("ownerCode", ownerCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "OnlineUserProductConfig/GetOnlineUserProductConfigByUserOwner", options)
            .map((response: Response) => response.json());
    }
    
    saveOnlineUserProductConfig(userProductConfigModel: UserProductConfigModel) {
        return this.http.post(AppSettings.apiEndpoint + "OnlineUserProductConfig/SaveOnlineUserProductConfig", userProductConfigModel)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/op/online-user-product-config.service.ts